module.exports = __webpack_public_path__ + "assets/groupPeople.3683f006.svg";